<template>
  <iImageContainer
    v-if="imageSrc || fallbackImageSrc"
    :whitespace-style="getOptionValue(ImageFillBackground)"
    :href="imageHref"
    :target="target"
    :shape="getOptionValue(ImageShape)"
    :show-placeholder="false"
    :width="myWidth"
    :height="myHeight"
    :min-height="getOptionValue(MinHeight)"
    :min-width="getOptionValue(MinWidth)"
    :max-height="getOptionValue(MaxHeight)"
    :max-width="getOptionValue(MaxWidth)"
    :src="imageSrc"
    :alt="imageAltText"
    :fallback-image="fallbackImageSrc"
    :object-position="getOptionValue(ObjectPosition)"
    :style-overrides="imageStyleOverrides"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :border-radius="myBorderRadius"
    :crop-if-needed="myCropIfNeeded"
    :aspect-ratio="myImageAspectRatio"
    :filter-effects="imageFilterEffects"
    :blend-mode="getOptionValue(BlendMode)"
    :rendering="getOptionValue(Rendering)"
  />
</template>

<script>
// Lightweight canvas render for unselected `ImageElement` instances.
// Mirrors `BaseImageElement.vue` but skips the editor-only placeholder
// (`show-placeholder` is hard-coded to false; selected elements still get
// the placeholder via the Builder variant) and the `myClipPath` watcher /
// `mounted` hook — clip-path is applied via the existing `v-bind` on the
// scoped `:deep(img)` rule, no DOM measurement needed.
import {
  SingleImageElementMixin,
} from "%/dynamic-component-editor/standard-elements/image-element/single-image-element-mixin";
import ImageFillBackground from "%/dynamic-component-editor/options/image-fill-background";
import ImageShape from "%/dynamic-component-editor/options/image-shape";
import ObjectPosition from "%/dynamic-component-editor/options/object-position";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import Crop from "%/dynamic-component-editor/options/crop";
import BlendMode from "%/dynamic-component-editor/options/blend-mode";
import Rendering from "%/dynamic-component-editor/options/rendering";

export default {
  name: "ImageElementProduction",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  mixins: [SingleImageElementMixin],
  data() {
    return {
      ImageFillBackground,
      ImageShape,
      ObjectPosition,
      MinHeight,
      MinWidth,
      MaxHeight,
      MaxWidth,
      Crop,
      BlendMode,
      Rendering,
    };
  },
};
</script>

<style lang="scss" scoped>
:deep(img) {
  clip-path: v-bind(myClipPath) !important;
}
</style>
